import { environment } from "src/environments/environment";

export class AppConfig {
    public static userImageStorageKey = 'users-images';
    public static channelImageStorageKey = 'channel-images';
    public static orgsServiceUrl = environment.remoteDataService + '/lots';
    public static userServiceUrl = environment.remoteDataService + '/lots';
    public static courseServiceUrl = environment.remoteDataService + '/lots';
    public static lessonServiceUrl = environment.remoteDataService + '/lots';
    public static borderServiceUrl = environment.remoteDataService;
    public static teacherFlag = true;
    public static firebaseLocalStorageKey = '2345Abcd78';
    public static app = {
        'app_pathname': 'lots',
        //'app_fullname': 'Naatyaguru',
        'app_fullname':'Toyota',
        'category': 'Style',
        'category_m': 'Styles',
        'channel': 'Class',
        'channel_m': 'Classes',
        'moyo': 'Session',
        'moyo_m': 'Sessions',
        'logo': '/assets/lots/logo/locSplash.png',
        'provider': 'TEACHER',
        'consumer': 'STUDENT',
        'default_user': '/assets/lots/logo/person-icon.svg',
        'default_moyo': 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAflBMVEUMDA3///8AAABQS0t3dXQICArS0NDp6enAwMDNy82YmJgFBQfe3t77+/vv7++dnZ319fUjIyQaGhvW1tZpaWmurq5YWFhQUFHu7u5BQULGxsa9u7uAfn4pKSpwcHCkpKRERESQkJETExMdHR6IiIk4NDRfXFw7OTpJSUknJygqjQMeAAAEHklEQVR4nO3d63KqMBSG4WRVBEUoHmitYqu1rd33f4Pb2FoOBsS9G1jJfO9fM6PPRI7GQcjagmko7Ig+4nqGqHshGhP1/clbR5v5zcJkQV7fn/uGSKQ3CiczeybwVEhZdIswmFoGFMKjxbK9MLVoE8yjT7+tcGfVJphHr8N2woGNE3iK9kEb4YOlM6giWl8V+o/WzqDKo/srwuWT1UBFHDcKY9uBmlksCX37gZezWBQ6MIOqCrEgtH4bPFf+ouZCJ76iX5VmMRfafZgo51F6KXxwCKguNdZVob2navpCGpWFbxafqumj6aQoTB2bQRWJOBcGzs2gih6Ss3Bi3xV9qyj7Fia23ZNpHe1OwmjhKvB4WFwp4dhZoNqh+lKsndzLnKOnSOxtuXX/b1EmXJ5BlcPbIELuF1JzfX++/y58D5pa2X89TXeyMfsvqCGEkH8QQsg/CCHkH4QQ8g9CCPkHIYT8gxBC/kEIIf8ghJB/EELIPwgh5B+EEPIPQgj5ByGE/IMQQv5BCCH/IISQfxBCyD8IIeQfhBDyD0II+QchhPyDEEL+QQgh/yCEkH8QQsg/CCHkH4QQ8g9CCPkHIYT8gxBC/kEIIf8ghJB/EELIPwgh5B+EEPIPQqNCr4un/1wTLq484KNNWlz+smHmNWHs/29L3RMLiR53c/XqfPdp+Dko14S/0OhC4NHTKn99dUcmH8bVh5CqT2t+eTU4jT0IQ7GqDpkbfK5hD0K6AEo5Mbe/6V5IL7pB5h6g2rmQ3vWjPkwRuxeu9aOGrghpG+tHRaaendW5MKsbZuoho50LtfsZ1doV4aRuWOy8MIHQFuG8bphv6LQGe5pfFw7qhjlztHj39aOSrSNCQWmbUTYLw32iGxR9OiOsOW/buXP1pP+eBi5dAQuveptGHSnM3VLs406UR9myOCB5M3mzrZe7iYIO45+Xo3Rr9KYwHYame9HeEaYsXQ+H6zQz/mRs8z8d6N/BO8nM39RXb2W6pnc2rkMIIYQQQgghhBBC6NZCYf2C7OZoIxZOEz0KRLxxmUhjKeRcmFxM3G/0LI9Cg2s0+4720UkoM0eJNFPrjJQwenaSGFIgv4UyNvZ7f599rzI6CaVvcl1/T52XNnwJja7r7ycaRCWhHHXwk2OX0eN5/c1ZaHRdQ/fR9meB0Y/weFh0h0iHfBlcLpRjZ4g0LSy4LQjlvSNEmhUXMhaFjswiHUpLpktCJ4hf52p1wuMX1fYLDZpW1tpWhNYTK19RjfB40LCZSNuL1dIXQhmYXjBmsPxMpkkoR39sJdJAs1RaI5QTO2/AhZRFGo1OKBNTf+ozGdX860QrlElm3YGRZoGWUiNUi+Dtmkba1/33q04oVzbtbzx61m2CzULpm/q/ze9HNK5lNAhl9GYJMdzUbIKn/gJKmkLVPZMNUAAAAABJRU5ErkJggg==',
        'default_channel': 'assets/images/logo.png',
        'default_category': 'assets/icons/bharathanatyam.png',
        'website': 'https://lightoftheself.net/',
        'default_unknown_image': '/assets/lots/icons/img.png',
        'completion_status_name': 'Completed',
        'news_default': 'Welcome to Naatyaguru Application.',
        'freeSessions':100,
        'app_splash_image':false,
        'name_splash_image':'assets/images/newlogo.png',
        'name_splash_image1':'assets/images/shikshalogo.png',
        'card_default_image': '/assets/images/card_img.png',
        'quiz_default_image': '/assets/images/quiz_img.jpg',
        'categories_to_sort': ["Module 1", "Module 2", "Module 3", "Module 4", "Module 5", "Safety Precautions for Hybrid Vehicle", "Handling Batteries in a Hybrid Vehicle", "Maintenance of Hybrid Vehicle", "Emergency Response for Hybrid Vehicle","toyota Rajajinagar","UI Developer"],
        'certificateKey':'toyota',
        'minimum_quiz_score':80,
        'unlockallsession':true
    }
    public static pages = {
        'course_component': {
            status: true,
            options: true,
            created_by: true,
            created_by_name_override_variable: 'false',
            created_by_name_override_suffix: '',
            created_by_image_replace_variable: 'false'
        },
        'AboutPage': {
            'app_name': 'LOTS App',
            'app_image': 'https://p.bigstockphoto.com/GeFvQkBbSLaMdpKXF1Zv_bigstock-Aerial-View-Of-Blue-Lakes-And--227291596.jpg',
            'app_description': "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.Ut enim ad minim veniam, quis nostrud exercitation ullamco"
        },
        'view_course': {
            'display_teacher_name': true,
            'display_teacher_details': true
        },
        'lesson_student_view': {
            'Demo_name': 'DEMO'
        }
    }
    public static mu_pages = {
        'display_teacher_name_and_details': false,
        'display_ratings': false,
        display_attributes:false,
        show_assignment_status: true,
        show_course_duration:false,
        show_course_progress:true,
        'multiRecommend':true,
        'login_button': 'SIGN UP',
        'FBLogin':true,
        'GoogleLogin':true,
        enableChat: true
    }
    public static intro_Notification() {
        return 'Welcome to Toyota Hybrid Vehicles e-Learning app!'
    }
    public static course_subbed_Notification(cname) {
        return 'You are now enrolled to e-Learning modules!' ;
    }

}


